import { ViewModeWidgetTitle } from './WidgetTitle';
import { DrilldownButton, DrilldownButtonProps } from './DrilldownButton';
import { WidgetHeaderBar } from './WidgetHeaderBar';
import { HeaderBarButtonGroup } from './HeaderBarButtonGroup';
import { IconName } from '@ardoq/icons';
import { IconButton } from '@ardoq/button';
import {
  ActiveDashboardFiltersIndicator,
  getActiveDashboardFiltersIndicatorProps,
} from './ActiveDashboardFiltersIndicator';
import { WidgetLinkedDashboardFilter } from '../types';
import { isEmpty } from 'lodash';
import { type I18nLocale, t } from '@ardoq/i18n';

export type ViewModeHeaderBarProps = {
  name: string;
  activeLinkedDashboardFilters?: WidgetLinkedDashboardFilter[];
  i18nLocale: I18nLocale;
} & (
  | {
      showDrilldownButton: true;
      drilldownButtonProps: DrilldownButtonProps;
    }
  | { showDrilldownButton: false }
) &
  (
    | {
        canOpenFullscreenWidget: true;
        openFullscreenWidget: VoidFunction | undefined;
      }
    | { canOpenFullscreenWidget: false }
  );

export const ViewModeHeaderBar = (props: ViewModeHeaderBarProps) => {
  const { i18nLocale } = props;
  return (
    <WidgetHeaderBar>
      <ViewModeWidgetTitle>{props.name}</ViewModeWidgetTitle>
      <HeaderBarButtonGroup>
        {props.canOpenFullscreenWidget && (
          <IconButton
            className="show-only-on-hover"
            onClick={props.openFullscreenWidget}
            iconName={IconName.FULLSCREEN}
            label={t(
              i18nLocale,
              'dashboard:headerBar.expandWidget',
              'Expand widget'
            )}
          />
        )}
        {props.showDrilldownButton && (
          <DrilldownButton {...props.drilldownButtonProps} />
        )}
        {props.activeLinkedDashboardFilters &&
          !isEmpty(props.activeLinkedDashboardFilters) && (
            <ActiveDashboardFiltersIndicator
              {...getActiveDashboardFiltersIndicatorProps(
                props.activeLinkedDashboardFilters,
                i18nLocale
              )}
            />
          )}
      </HeaderBarButtonGroup>
    </WidgetHeaderBar>
  );
};
